import { useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { message } from 'antd';
import { RootState } from '@/store';
import { logger } from '@/lib/logger';

const AuthListener = () => {
  const isAuthenticated = useSelector(
    (state: RootState) => state.auth.isAuthenticated,
  );
  const userId = useSelector(
    (state: RootState) => state.auth.userData?.userId,
  );
  const navigate = useNavigate();
  const prevAuthRef = useRef<boolean>(isAuthenticated);

  // Correlate telemetry to the user by id (covers login and page-reload session restore).
  useEffect(() => {
    if (isAuthenticated && userId != null) {
      logger.setUser(userId);
    } else if (!isAuthenticated) {
      logger.clearUser();
    }
  }, [isAuthenticated, userId]);

  useEffect(() => {
    if (prevAuthRef.current && !isAuthenticated) {
      message.info('Your session has expired. Please log in again.');
      navigate('/auth');
    }
    prevAuthRef.current = isAuthenticated;
  }, [isAuthenticated, navigate]);

  return null; // This component doesn't render anything
};

export default AuthListener;
